/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { belongsTo, attr } from '@ember-data/model';

export default class Keyword extends Model {
  @attr('string') name;
  @belongsTo('sms/keyword-response', { inverse: 'keywords' }) keywordResponse;
}
